import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import General from "../../src/stores/GeneralStore";
import {  } from "./ShowSuccess";
import { NotifyError } from "./ShowError";

let values: any = {};

export const setValues = (labels: any) => {
  values = labels;
};
export const ErrorWrapperShow = (code: any, message?: any) => {
  const notify = (message: any) => NotifyError(message);
  if (message) {
    notify(code);
  } else {
    if (code?.includes("MSG")) {
      const messageNew = "cm_" + code.toLowerCase();
      notify(General?.codeLabels[messageNew]?.label);
    } else {
      notify(General?.codeLabels[code]?.label);
    }
  }

  // notify(General?.codeLabels[code].label);
};
